import { DataStatus } from 'models'

export enum LabelType {
  InstanceAdded = 'InstanceAdded',
  InstanceRemoved = 'InstanceRemoved',
  SLAChanged = 'SLAChanged',
  CPIActivated = 'CPIActivated',
  CustomLabel = 'CustomLabel'
}

export enum CPIPeriod {
  OneMonth = '1M',
  ThreeMonths = '3M',
  SixMonths = '6M',
  OneYear = '1Y'
}

export interface CategoryMetaData {
  weight: string
  dateActivated: string
  activeIntegrations: number
  activeCPIs: number
}

export interface TrendDataPoint {
  date: string
  fullDate: string
  xLabel: string
  value: number | null
  // Constant zero rendered as a transparent Line so recharts always has a
  // payload at every x position. Without this the Tooltip stays inactive
  // over weeks where `value` is null and the user gets no "No data" hint.
  tooltipAnchor: 0
}

export interface PerformanceData {
  score: number
  changeFromLastMonth: number | null
  lastUpdate: string
  trendData: TrendDataPoint[]
}

export interface BenchmarkChartPoint {
  date: string
  fullDate: string
  xLabel: string
  less: number
  same: number
  more: number
}

export interface BenchmarkingData {
  industry: string
  lessStrict: number
  sameSLA: number
  moreStrict: number
  lastUpdate: string
  chartData: BenchmarkChartPoint[]
}

export interface InsightsSummary {
  performanceDegradation: number
  suggestedOptimization: number
  performanceImprovement: number
}

export interface LabelItem {
  id: string
  type: LabelType
  title: string
  cpiName: string
  description: string
  date: string
  isPublic: boolean
  author?: string
  slaChange?: { from: string; to: string }
}

export interface ActiveCPI {
  cpiId: string
  cpiName: string
  name: string
  performance: number
  changeFromLastMonth: number | null
  weight: string
  benchmarkingScore: number | null
  recentFindingValue: string
  recentFindingChange: number | null
  recentFindingDirection: 'asc' | 'desc'
  labelsCount: number
  status?: DataStatus
}

export interface AvailableCPI {
  cpiId: string
  cpiName: string
  name: string
  description: string
  dataSourceLogos: string[]
  isV2: boolean
  configuredIntegrationIds: string[]
  configuredInstanceNames: string[]
}

export interface CategoryDashboardData {
  metaData: CategoryMetaData
  performance: PerformanceData
  benchmarking: BenchmarkingData
  insights: InsightsSummary
  labels: LabelItem[]
  activeCPIs: ActiveCPI[]
  availableCPIs: AvailableCPI[]
}
